export const templateAction = (item) => {
  return {
    type: 'TEMPLATE',
    item,
  };
};
